<script setup lang="ts">
const Icon = useIcon();
import { TellerIcon } from 'assets/data/icons';
</script>
<template>
  <Icon :path="TellerIcon" class="w-8" filled />
</template>
